<template>
  <button class="top-3" title="Close chat window" aria-label="Close chat" @click="chatBotStore.toggleChat()">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.076 2.076a.6.6 0 0 1 .848 0L8 7.152l5.076-5.076a.6.6 0 0 1 .848.848L8.848 8l5.076 5.076a.6.6 0 0 1-.848.848L8 8.848l-5.076 5.076a.6.6 0 0 1-.848-.848L7.152 8 2.076 2.924a.6.6 0 0 1 0-.848Z"
      />
    </svg>
  </button>
</template>
<script setup lang="ts">
import { useChatBotStore } from "../stores/chatBotStore";
const chatBotStore = useChatBotStore();
</script>
